export default "https://assets.egbcdn.net/assets/packs/_/images/svg_icons/logo-framed-81292d83858c7df886c29b9df3329e8a.svg";